export default "__VITE_ASSET__C3hXp9Kb__"